import {
  HTTP_GETAPPROVEHISTORY_FETCHING,
  HTTP_GETAPPROVEHISTORY_SUCCESS,
  HTTP_GETAPPROVEHISTORY_FAILED,
} from "././../../Constants";

const initialState = {
  result: [],
  isFetching: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_GETAPPROVEHISTORY_FETCHING:
      return {
        ...state,
        result: [],
        isFetching: true,
        isError: false,
      };
    case HTTP_GETAPPROVEHISTORY_SUCCESS:
      return {
        ...state,
        result: payload.data,
        isFetching: false,
        isError: false,
      };
    case HTTP_GETAPPROVEHISTORY_FAILED:
      return {
        ...state,
        result: [],
        isFetching: false,
        isError: true,
      };
    default:
      return state;
  }
};
